import makeServerVariables from '@/utils/serverVariables';

makeServerVariables();

__webpack_public_path__ = serverVariables.httpRequest.basePath;

if (__webpack_require__ && typeof __webpack_require__ === 'object') {
	__webpack_require__.p = serverVariables.httpRequest.basePath
}
